<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm
          ref="dnnBaseInfoId" :formId="formItems.dnnBaseInfoId.formId" :formParams="formItems.dnnBaseInfoId.formObj" :opCode="opCode"></ParseForm>
      </template>
      <template>
        <ParseForm ref="dnnParamInfoId" :formId="formItems.dnnParamInfoId.formId" :formParams="formItems.dnnParamInfoId.formObj" :opCode="opCode"  :Title="formItems.dnnParamInfoId.title"></ParseForm>
      </template>  
      <template>
        <ParseForm ref="pduSessionParamId" :formId="formItems.pduSessionParamId.formId" :formParams="formItems.pduSessionParamId.formObj" :opCode="opCode"  :Title="formItems.pduSessionParamId.title"></ParseForm>
      </template>  
      <template>
        <ParseForm ref="sccModeParamId" :formId="formItems.sccModeParamId.formId" :formParams="formItems.sccModeParamId.formObj" :opCode="opCode" :Title="formItems.sccModeParamId.title"></ParseForm>
      </template>  
      <template>
        <ParseForm ref="qosParamId" :formId="formItems.qosParamId.formId" :formParams="formItems.qosParamId.formObj" :opCode="opCode" :Title="formItems.qosParamId.title"></ParseForm>
      </template>  
    </div>
  </div>
</template>

<script>
import ParseForm from '../../../util/parseFormNew/ParseForm';
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ajaxUrl from "../../../data/ajaxUrl";

export default {
  name: "ModProfileForm",
  components: {
    ParseForm,
  }, 
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.dnnBaseInfoId) {
        if (!this.$refs.dnnBaseInfoId.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.dnnBaseInfoId.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.dnnParamInfoId) {
        if (!this.$refs.dnnParamInfoId.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.dnnParamInfoId.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.pduSessionParamId) {
        if (!this.$refs.pduSessionParamId.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.pduSessionParamId.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.sccModeParamId) {
        if (!this.$refs.sccModeParamId.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.sccModeParamId.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.qosParamId) {
        if (!this.$refs.qosParamId.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.qosParamId.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      return map;
    },
    getJson(ne, checkedDatas, callback) {
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      this.$axios.post(ajaxUrl.udmJsonReq, params).then(response => {
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        console.log("checkedDatas[0]",checkedDatas[0])
        var type=0;
       checkedDatas[0].pduSessionType.split(";")
      .filter((item) => { return item !== "" })
      .map((item) => {
        if(item=="IPv4"){
          type=type+1;
        }
        if(item=="IPv6"){
          type=type+10;
        }
        if(item=="IPv4v6"){
          type=type+100;
        }
        if(item=="TRUCTURED"){
          type=type+1000;
        }
        if(item=="ETHERNET"){
          type=type+10000;
        }            
      })
      checkedDatas[0].pduSessionType=parseInt(type,2);
      var sscModetype=0;
      checkedDatas[0].sscMode.split(";")
      .filter((item) => { return item !== "" })
      .map((item) => {
        if(item=="SSC_MODE_1"){
          sscModetype=sscModetype+1;
        }
        if(item=="SSC_MODE_2"){
          sscModetype=sscModetype+10;
        }
        if(item=="SSC_MODE_3"){
          sscModetype=sscModetype+100;
        }
       })
      checkedDatas[0].sscMode=parseInt(sscModetype,2);
        console.log("checkedDatas[0]222",checkedDatas[0])
        const res = response.data.resultVal;
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(res, checkedDatas[0]);
        this.formItems.dnnBaseInfoId.formObj = resultMap.get(this.formItems.dnnBaseInfoId.modelName);
        this.formItems.dnnParamInfoId.formObj = resultMap.get(this.formItems.dnnParamInfoId.modelName);
        this.formItems.pduSessionParamId.formObj = resultMap.get(this.formItems.pduSessionParamId.modelName);
        this.formItems.sccModeParamId.formObj = resultMap.get(this.formItems.sccModeParamId.modelName);
        this.formItems.qosParamId.formObj = resultMap.get(this.formItems.qosParamId.modelName);
        callback(response);
      });      
    },
    getKey(obj, value) {
      for(let key in obj){
        if (value === obj[key]) {
          return Number(key);
        }
      }
    },
    saveProfile(ne, callback) {
      const formData = this.getDatas();
      if (formData) {
        console.log("formData",formData);
        let pduSessionTypeList=[];
        let pduSessionTypeStr=formData.get("pduSessionType");
                console.log("pduSessionTypeStr",pduSessionTypeStr);

        if(pduSessionTypeStr>=16){
          pduSessionTypeStr=formData.get("pduSessionType").toString(2);
          pduSessionTypeList=[parseInt(pduSessionTypeStr[4]),parseInt(pduSessionTypeStr[3]),parseInt(pduSessionTypeStr[2]),parseInt(pduSessionTypeStr[1]),parseInt(pduSessionTypeStr[0])];
        }else{
          pduSessionTypeStr=formData.get("pduSessionType").toString(2);
          var pduSessionTypeSize = pduSessionTypeStr.length;    //获取要格式化数字的长度，如二进制1的话长度为1
          if(pduSessionTypeSize < 4){     //补全位数 0000，这里我要显示4位
            for(var i = 0; i < 4-pduSessionTypeSize; i++) {
              pduSessionTypeStr = "0" + pduSessionTypeStr;     //不够的就在前面补0
            }
          }
          pduSessionTypeList=[parseInt(pduSessionTypeStr[3]),parseInt(pduSessionTypeStr[2]),parseInt(pduSessionTypeStr[1]),parseInt(pduSessionTypeStr[0]),0];
                          console.log("pduSessionTypeList",pduSessionTypeList);

        }
        let sscModeStr=formData.get("sscMode").toString(2);
        var sscModeSize = sscModeStr.length;    
        if(sscModeSize < 4){    
           for(var i = 0; i < 4-sscModeSize; i++) {
            sscModeStr = "0" + sscModeStr;     
           }
        }
        let sscModeList=[parseInt(sscModeStr[3]),parseInt(sscModeStr[2]),parseInt(sscModeStr[1])];
       
        const params = { 
          vo: {
            neid: ne.neid,
            profileId: parseInt(formData.get("profileId")),
            profileName: formData.get("profileName"),
            dnnName: formData.get("dnnName"),
            ambrUp: parseInt(formData.get("ambrUp")),
            ambrDown: parseInt(formData.get("ambrDown")),
            chargeChars: formData.get("chargeChars"),
            pduSessionType: pduSessionTypeList,
            dftPduSessionType: formData.get("dftPduSessionType"),
            sscMode: sscModeList,
            dftSscMode: formData.get("dftSscMode"),
            fiveQi: parseInt(formData.get("fiveQi")),
            fiveQiPriorityLevel: (null==formData.get("fiveQiPriorityLevel")||""==formData.get("fiveQiPriorityLevel"))?0:parseInt(formData.get("fiveQiPriorityLevel")),
            pl: formData.get("pl"),
            pev: formData.get("pev"),
            pec: formData.get("pec"),
            defaultIndicator: formData.get("defaultIndicator"),
            // lboRoamingAllowed: formData.get("lboRoamingAllowed"),
          }, 
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          }
        };
        this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => {
          if (callback) {
            callback(response);
          }
        });
      } 
    }, 
  },
  data() {
    return {
     descPDU: {
        0: this.$t("DNN.pduType0"),
        1: this.$t("DNN.pduType1"),
        2: this.$t("DNN.pduType2"),
        3: this.$t("DNN.pduType3"),
        4: this.$t("DNN.pduType4"),
      },
      formItems: {        
      dnnBaseInfoId: {
          formId: "DNNModBaseInfo",
          modelName: "dnnBaseInfoId",
          formObj: null
        },
        dnnParamInfoId: {
          title: this.$t("DNN.dnnParamInfo"),
          formId: "DNNModParamInfo",
          modelName: "dnnParamInfoId",
          formObj: null
        },
        pduSessionParamId: {
          title: this.$t("DNN.pduSessionParamInfo"),
          formId: "DNNModPduSession",
          modelName: "pduSessionParamId",
          formObj: null
        },
        sccModeParamId: {
          title: this.$t("DNN.sscModeParamInfo"),
          formId: "DNNModSccMode",
          modelName: "sccModeParamId",
          formObj: null
        },
        qosParamId: {
          title: this.$t("DNN.qosParamInfo"),
          formId: "DNNModQos",
          modelName: "qosParamId",
          formObj: null
        },
      },
      opCode: "mod",
      msgId: "28673"
          };
  },
  //   computed: {
  //   parseOpCode() {      
  //     return this.opCode + '';
  //   }
  // }
};
</script>

